import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import { ReturnableExperience } from '../../../../Common/Experience/Types';
import { dateToLocalDateTime } from '../../Types';

interface Props {
  experience: ReturnableExperience;
}

function ReturnableCardHeader({ experience }: Props) {
  return (
    <>
      <Typography variant="h5" color="white">
        <T kind="Graduated" />
      </Typography>
      <Typography className="mt-3" color="white" variant="bodySmall">
        <T
          kind="Graduated from <span>{{date}}</span> cohort."
          date={dateToLocalDateTime(experience.startOn)}
          span={(value) => (
            <Typography color="white" variant="bodySmall" fontWeight="bold" as="span">
              {value}
            </Typography>
          )}
        />
      </Typography>
    </>
  );
}

export default observer(ReturnableCardHeader);
